import { Component } from "@angular/core";

@Component({
  selector: "app-not-found-svg",
  standalone: true,
  templateUrl: "./svg.html",
  styles: [
    `
      :host {
        display: block;
        max-width: 400px;
        margin: 0 auto;
      }
    `,
  ],
})
export class NotFoundSvgComponent {}
